import React from "react";
import GridCard from "./GridCard";

interface Props {
  data?: string[][];
  loading: boolean;
}

const LeaveOfAbsenceCard: React.FC<Props> = ({ data, loading }) => {
  if (!data || data.length === 0) return null;

  return (
    <GridCard
      title="Leave of Absence"
      headers={["Start Date", "End Date"]}
      data={data}
      loading={loading}
    />
  );
};

export default LeaveOfAbsenceCard;